import React from "react";
import { Typography, Row, Col, Progress as AntProgress } from "antd";

const { Title } = Typography;

/**
 * Network Detection via detection library.
 *
 * @param {object} props
 */

const NetworkTests = (props) => {
  const { latencyProgress, uploadProgress, downloadProgress } = props;

  return (
    <>
      <Row className='mt-5' justify='space-around' align='middle'>
        <Col span={6}>
          <div>
            <AntProgress type='circle' percent={latencyProgress} />
          </div>
          <Title level={4}>Latency</Title>
        </Col>
        <Col span={6}>
          <div>
            <AntProgress type='circle' percent={downloadProgress} />
          </div>
          <Title level={4}>Download Speed</Title>
        </Col>
        <Col span={6}>
          <div>
            <AntProgress type='circle' percent={uploadProgress} />
          </div>
          <Title level={4}>Upload Speed</Title>
        </Col>
      </Row>
    </>
  );
};

export default NetworkTests;
